// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1U_tv","inputWrap":"styles_inputWrap__3_TNu","input":"styles_input__147Wl"};